module.exports = __webpack_public_path__ + "static/media/microsoft.53311245.svg";